import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import CircleType from "circletype";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Banner01 from "../../../assets/images/background/banner-two-bg-my.png";
import Banner02 from "../../../assets/images/background/banner-two-bg-my.png";
import Banner03 from "../../../assets/images/background/banner-two-bg-my.png";
import Banner04 from "../../../assets/images/background/banner-two-bg-my.png";

const Bannertwo = () => {
  const circleRef = useRef(null);

  useEffect(() => {
    if (circleRef.current) {
      new CircleType(circleRef.current).radius(91);
    }
  }, []);

  const Bannerslider = {
    dots: true,
    infinite: true,
    speed: 800,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    arrows: false,
    customPaging: (i) => (
      <div
        className="custom-dot"
        tyle={{ color: "var(--caprim-secondary-beige)" }}
      >
        {
          [
            "Dispersión y recaudo",
            "Pagos transfronterizos",
            "Tesorería en la nube",
          ][i]
        }
      </div>
    ),
  };

  return (
    <section className="banner-two">
      <div className="container-fluid p-0">
        <Slider {...Bannerslider} className="banner-two-slider">
          {[Banner01, Banner02, Banner03, Banner04].map((banner, index) => (
            <div key={index} className="banner-two-slider-item">
              <div className="banner-two-slider-item-image zoom-in">
                <img src={banner} alt={`banner-${index + 1}`} />
              </div>
              <div className="container">
                <div className="row">
                  <div className="col-lg-10 m-auto">
                    <div className="banner-two-info text-center">
                      {/* <div className="section-details fade-left">
                                                <p>Pioneering Financial Solutions</p>
                                            </div> */}
                      <div className="section-details fade-left">
                        <p>Infraestructura de pagos para empresas</p>
                      </div>
                      <div className="banner-title fade-left">
                        <h1>
                          Recibe pagos, paga a quien lo necesites, y mueve
                          dinero entre Colombia,{" "}
                          <span className="banner-title__strong-yellow">
                            Estados Unidos y China
                          </span>{" "}
                          — todo desde{" "}
                          <span className="banner-title__strong-yellow">
                            un solo lugar
                          </span>
                          .
                        </h1>
                      </div>
                      <div className="banner-two-btn">
                        <Link to="/Contactus" className="btn btn-outline-secondary">
                          Contáctanos <i className="flaticon-next" />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
        <div className="banner-two__circle">
          <span className="banner-two-icon">
            <i
              className="flaticon-real-estate"
              style={{ color: "var(--caprim-secondary-beige)" }}
            />
          </span>
          <div className="curved-circle">
            <div
              {...{
                style: { display: "inline-block" },
                role: "text",
                ref: circleRef,
              }}
              className="curved-circle--item"
            >
              3+ AÑOS DE EXPERIENCIA
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Bannertwo;
